import { Component, Input } from '@angular/core';
import { NewsArticle } from '@models/newsArticle';

@Component({
  selector: 'csl-home-section-three-boxes',
  templateUrl: './home-section-three-boxes.component.html'
})
export class HomeSectionThreeBoxesComponent {
  @Input()
  newsArticles: NewsArticle[];

  @Input()
  articleSection: string;

  @Input()
  articleSectionDescription: string;

}
